const base_url ='http://localhost:5003';
export default base_url;